import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type ApiResponseValue = {
  altura: number | null;
  alturaExport: number | null;
  alturaImport: number | null;
  armador: string;
  armadorExport: string | null;
  armadorImport: string | null;
  armadorSlotExport: string | null;
  armadorSlotImport: string | null;
  bayExport: string | null;
  bayImport: string | null;
  bloqueos: string | null;
  booking: string | null;
  buqueExport: string | null;
  buqueImport: string | null;
  cuitata: string | null;
  cuitExportador: string | null;
  calle: string | null;
  categoria: string | null;
  codigoPermisoEmbarque: string | null;
  codigoPermisoEmbarqueExport: string | null;
  contenedor: string | null;
  controlaAtmosfera: boolean;
  controlaAtmosferaSpecified: boolean;
  controlaHumedad: boolean;
  controlaHumedadSpecified: boolean;
  cutoff: string;
  cutoffSpecified: boolean;
  descripcionMercaderia: string | null;
  destino1: string | null;
  destino2: string | null;
  destino3: string | null;
  disponibilidad: string;
  disponibilidadSpecified: boolean;
  enVenta: boolean;
  enVentaSpecified: boolean;
  esReefer: boolean;
  esReeferSpecified: boolean;
  estadia: number;
  estadiaSpecified: boolean;
  estado: string;
  estadoDisponibilidad: string | null;
  estadoEstructura: string | null;
  estadoLimpieza: string | null;
  estadoMotor: string | null;
  estiba: string | null;
  exportador: string | null;
  fechaPTI: string;
  fechaPTISpecified: boolean;
  importTransito: boolean;
  importTransitoSpecified: boolean;
  importVacio: boolean;
  importVacioSpecified: boolean;
  iso: string | null;
  lateral: string | null;
  lateralExport: string | null;
  lateralImport: string | null;
  llegadaExport: string;
  llegadaExportSpecified: boolean;
  llegadaImport: string;
  llegadaImportSpecified: boolean;
  llego: string;
  manufactura: string;
  manufacturaSpecified: boolean;
  marca: string;
  mgw: number;
  mgwSpecified: boolean;
  modelo: string | null;
  motor: string | null;
  numero: string;
  oidExport: number;
  oidExportSpecified: boolean;
  oidImport: number;
  oidImportSpecified: boolean;
  oidVisita: number;
  oidVisitaSpecified: boolean;
  origenImport: string | null;
  payLoad: string | null;
  playa: string;
  precintoConvalidadoExport1: string | null;
  precintoConvalidadoExport2: string | null;
  precintoConvalidadoExport3: string | null;
  precintoConvalidadoExport4: string | null;
  precintoConvalidadoImport1: string | null;
  precintoConvalidadoImport2: string | null;
  precintoConvalidadoImport3: string | null;
  precintoConvalidadoImport4: string | null;
  precintoExport1: string | null;
  precintoExport2: string | null;
  precintoExport3: string | null;
  precintoExport4: string | null;
  precintoImport1: string | null;
  precintoImport2: string | null;
  precintoImport3: string | null;
  precintoImport4: string | null;
  razonSocialATA: string | null;
  razonSocialExportador: string | null;
  salidaExport: string;
  salidaExportSpecified: boolean;
  seFue: boolean;
  seFueSpecified: boolean;
  statusExport: string | null;
  stock: string | null;
  tamano: number;
  tamanoSpecified: boolean;
  tara: number;
  taraSpecified: boolean;
  temperaturaExport: string | null;
  temperaturaMaxima: number;
  temperaturaMaximaSpecified: boolean;
  temperaturaMinima: number;
  temperaturaMinimaSpecified: boolean;
  tipo: string;
  tipoTamano: string | null;
  totalKgNeto: string | null;
  unidadTemperatura: string | null;
  unidadTemperaturaExport: string | null;
  vendido: boolean;
  vendidoSpecified: boolean;
  viajeExport: string | null;
  viajeImport: string | null;
  oidpreparacion: number;
  oidpreparacionSpecified: boolean;
  isSuccess: boolean;
  exception: {
    message: string;
  };
};

type ApiResponse = {
  isSuccess: boolean;
  value: ApiResponseValue;
};

type Query = {
  marca: string;
  numero: string;
};

export const getOidVisitaAbierta = async (
  query: Query
): Promise<ApiResponseValue> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.ObtainVisitaAbierta,
      query
    );
    const { isSuccess, value } = res.data;
    if (!isSuccess || value?.isSuccess === false)
      throw new Error(
        value?.exception?.message ||
          'No se ha podido obtener el oid de la visita abierta'
      );

    return res.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
